import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export default function EduSearch({
  placeholder = "Search articles, guides, and glossary…",
  size = "lg",
  defaultValue = "",
  testid = "edu-search",
}) {
  const [q, setQ] = useState(defaultValue);
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const query = q.trim();
    if (query) navigate(`/education/search?q=${encodeURIComponent(query)}`);
  };

  const big = size === "lg";

  return (
    <form onSubmit={submit} className="relative w-full" data-testid={testid}>
      <Search
        className={
          "pointer-events-none absolute left-5 top-1/2 -translate-y-1/2 text-slatey " +
          (big ? "h-5 w-5" : "h-4 w-4")
        }
      />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder}
        data-testid={`${testid}-input`}
        className={
          "w-full border border-line bg-white text-navy outline-none transition-colors placeholder:text-slatey/60 focus:border-electric " +
          (big ? "py-5 pl-14 pr-32 text-base" : "py-3.5 pl-12 pr-28 text-sm")
        }
      />
      <button
        type="submit"
        data-testid={`${testid}-submit`}
        className={
          "absolute right-2 top-1/2 -translate-y-1/2 bg-electric font-medium text-white transition-transform hover:scale-[0.97] hover:bg-electric-hover " +
          (big ? "px-6 py-3 text-sm" : "px-4 py-2 text-xs")
        }
      >
        Search
      </button>
    </form>
  );
}
